export const loadGMapsAPI = new Promise( (resolve) => {
  window.GMapsCallback = resolve;
  if (window.google) {
    return; // prevent the script from including the Google Maps JavaScript API multiple times
  }
  // include Google Maps JavaScript API
  const script = document.createElement('script');
  script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.VUE_APP_GMAPS_API_KEY}&callback=GMapsCallback`;
  document.body.appendChild(script);
});